export class ClaimDetailConstant {
  public static readonly AUTO_RENTAL_REIMBURSEMENT_COVERAGE = 'AUTO RENTAL REIMBURSEMENT COVERAGE';
  public static readonly RENTAL_CLASSIC_REIMBURSEMENT_COVERAGE = 'RENTAL REIMBURSEMENT';
  public static readonly RENTAL_PER_DAY_LIMIT_CODE = 'LXDPERDAY';
  public static readonly RENTAL_MAXIMUM_LIMIT_CODE = 'LXDMAXIMUM';
  public static readonly RENTAL_CLASSIC_DAILY_LIMIT_CODE = 'DAILY LIMIT';
  public static readonly RENTAL_CLASSIC_MAXIMUM_LIMIT_CODE = 'MAXIMUM';
  public static readonly DREAM_REPAIR_PROGRAM = 'DREAM REPAIR PROGRAM';
  public static readonly RENTAL = 'RENTAL';
  public static readonly TOWING = 'TOWING';
  public static readonly REPAIR_SHOP = 'Repair Shop';
  public static readonly TOWING_SHOP = 'Towing Company';
  public static readonly BUSINESS = 'BUSINESS';
  public static readonly FIRST_PARTY = 'FIRST PARTY';
  public static readonly THIRD_PARTY = 'THIRD PARTY';
  public static readonly PROPERTY = 'PROPERTY';
  public static readonly AUTO = 'AUTO';
}
